module.exports = __webpack_public_path__ + "static/img/theme_04.4d4dc5d5.png";